import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "@/admin/AuthContext";

export default function RequireAdmin({ children }) {
  const { admin, ready } = useAdmin();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="admin-session-loading" aria-busy="true">
        <span className="h-8 w-8 animate-spin rounded-full border-2 border-[var(--cw-brand-secondary)] border-t-primary" />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return children;
}
